// Utils
import { component } from 'picoapp';

import choozy from 'utils/choozy';

export default component((node) => {
  const { input = [] } = choozy(node);

  const inputs = [].concat(input);

  const { formId, productId } = node.dataset;

  const handleChange = (e) => {
    e.stopPropagation();

    node.dispatchEvent(
      new CustomEvent(`${productId}:${formId}:fit-change`, { bubbles: true, cancelable: true }),
    );
  };

  const handleUpdate = (e) => {
    e.stopPropagation();

    const { currentProductId } = e.detail;

    inputs.forEach((_input) => {
      _input.checked = parseInt(_input.value, 10) === currentProductId;
    });
  };

  node.addEventListener('change', handleChange);

  document.addEventListener(`${productId}:${formId}:update`, handleUpdate);

  document.addEventListener(
    `${productId}:${formId}:unmount`,
    () => {
      document.removeEventListener(`${productId}:${formId}:update`, handleUpdate);
    },
    { once: true },
  );
});
